import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import BrandedWordmark from './BrandedWordmark';
import { ResolvedBranding } from '../utils/brandingStorage';
type TenantLogoProps = {
  branding: ResolvedBranding;
  variant?: 'login' | 'appBar' | 'compact';
  failed?: boolean;
  onError?: () => void;
  wordmarkSx?: SxProps<Theme>;
  wordmarkTone?: 'default' | 'onPrimary';
};

/** Renders tenant logo icon + wordmark (shared Provysn mark; tenant name/colors differ). */
const TenantLogo: React.FC<TenantLogoProps> = ({
  branding,
  variant = 'login',
  failed = false,
  onError,
  wordmarkSx,
  wordmarkTone = 'default'
}) => {
  const src = variant === 'appBar' ? branding.logoOnDark : branding.logoMark;

  if (failed || !src) {
    return (
      <BrandedWordmark
        name={branding.companyName}
        variant={variant === 'appBar' ? 'h6' : 'h6'}
        tone={wordmarkTone}
        sx={wordmarkSx}
        baseSx={wordmarkSx}
      />
    );
  }

  const iconSize = variant === 'appBar' ? { xs: 32, sm: 36 } : variant === 'compact' ? 40 : 52;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
      <Box
        component="img"
        src={src}
        alt=""
        aria-hidden
        onError={onError}
        sx={{
          height: iconSize,
          width: iconSize,
          objectFit: 'contain',
          flexShrink: 0,
          display: 'block',
          ...(variant === 'appBar'
            ? {}
            : {
                borderRadius: 2,
                boxShadow: '0 1px 3px rgba(15,23,42,0.12)'
              })
        }}
      />
      <BrandedWordmark
        name={branding.companyName}
        variant="h6"
        tone={wordmarkTone}
        sx={wordmarkSx}
        baseSx={wordmarkSx}
      />
    </Box>
  );
};

export default TenantLogo;
